import styled from 'styled-components'

const ToolboxGroupTitleUi = styled.div`
  color: var(--default-text-color);
  font-size: var(--default-font-size);
  margin-bottom: 10px;
`

export default ToolboxGroupTitleUi
